import { LinkActionStatus } from '../types/LinkActionStatus';
import { RecipientPermissionResult } from '../types/RecipientPermissionResult';
import { RecipientPermissionInfo, SharingTipId } from 'owa-sharing-data';
import { action } from 'satcheljs';

export const addRecipientsIntoLink = action(
    'ADD_RECIPIENTS_INTO_LINK',
    (linkId: string, recipients: RecipientPermissionInfo[]) => ({
        linkId: linkId,
        recipients: recipients,
    })
);

export const updateRecipientPermissionInfos = action(
    'UPDATE_RECIPIENT_PERMISSION_INFO',
    (linkId: string, results: RecipientPermissionResult[]) => ({
        linkId: linkId,
        results: results,
    })
);

export const removeRecipientsFromLink = action(
    'REMOVE_RECIPIENTS_FROM_LINK',
    (linkId: string, recipients: RecipientPermissionInfo[]) => ({
        linkId: linkId,
        recipients: recipients,
    })
);

export const setGetPermissionInfoFailure = action(
    'SET_GET_PERMISSION_INFO_FAILURE',
    (linkId: string, recipients: RecipientPermissionInfo[]) => ({
        linkId: linkId,
        recipients: recipients,
    })
);

export const resetSharingRecipientsInfo = action(
    'RESET_SHARING_RECIPIENTS_INFO',
    (linkId: string) => ({ linkId: linkId })
);

export const setLinkActionStatus = action(
    'SET_ACTION_STATUS',
    (linkId: string, linkActionStatus: LinkActionStatus) => ({
        linkId: linkId,
        linkActionStatus: linkActionStatus,
    })
);

// Only used by view, but still here so that it will be lazy loaded, as it imports from owa-sharing-data.
// Consider moving to internalActions after owa-sharing-data is truely lazy
export const ignoreSharingTip = action(
    'IGNORE_SHARING_TIP',
    (linkId: string, sharingTipId: SharingTipId) => ({
        linkId: linkId,
        sharingTipId: sharingTipId,
    })
);
